import type { ContactEventType } from '@/api/entity_types/ContactEvent';

const linkTag = (eventType: ContactEventType) =>
  eventType === 'interview' ? '{{scheduling_link.interview}}' : '{{scheduling_link.phone_screen}}';

export const defaultEmailSubject = () => {
  return 'Schedule Your Interview with {{team.company}}';
};

export const defaultEmailBody = (eventType: ContactEventType) => {
  return `<p>Hi {{contact.first_name}},</p><p><br></p><p>We'd love to schedule an interview with you. Please use the link below to pick a time that works:</p><p><br></p><p>${linkTag(eventType)}</p>`;
};

export const defaultSmsMessage = (eventType: ContactEventType) => {
  return `Hi {{contact.first_name}}, we'd love to schedule an interview with you at {{team.company}}! Pick a time that works: ${linkTag(eventType)}`;
};
